import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash';
import { mapProps } from 'recompose';

import { getScarcityFlag } from 'utils/store/getScarcityFlag';

import UnitDescription from './UnitDescription';
import UnitPrice from './UnitPrice';
import UnitListItem from './UnitListItem';
import { Image } from 'components/core/Image';

import fivexfive from '/assets/images/unit-icons/new/5x5.svg';

import './UnitDetails.scss';
import { getUnitImageUrl } from '../../../utils/units';

export const enhance = mapProps(
	({ amenitiesText, unit, priceSize, className, facility, showIcon }) => ({
		amenitiesText,
		priceSize,
		className,
		vehicleAccommodation: unit.vehicleAccommodation,
		promotion: unit.promotion,
		sizeText: unit.sizeText,
		unitTypeText: unit.unitTypeText,
		price: unit.price.text,
		regularPrice:
			get(unit, 'regularPrice.value') !== get(unit, 'price.value')
				? get(unit, 'regularPrice.text', null)
				: null,
		isScarce: getScarcityFlag([unit]),
		unitQuantity: unit.quantity,
		facility,
		unit,
		showIcon: showIcon,
	})
);

export function UnitDetails({
	className,
	amenitiesText,
	vehicleAccommodation,
	sizeText,
	unitTypeText,
	promotion,
	price,
	priceSize,
	regularPrice,
	isScarce,
	unitQuantity,
	facility,
	unit,
	showIcon,
}) {
	return (
		<UnitListItem
			className={classnames('atomic-unit-details', 'unit-details', className)}
		>
			<div className="unit-details">
				{showIcon && (
					<Image
						src={getUnitImageUrl(unit.length, unit.width) || fivexfive}
						alt={sizeText}
						className="unit-size-icon"
						lazyLoad={false}
					/>
				)}
				<UnitDescription
					unitSize={sizeText}
					unitType={unitTypeText}
					promotion={promotion}
					isScarce={isScarce}
					unitQuantity={unitQuantity}
				/>

				<UnitPrice
					price={price}
					regularPrice={regularPrice}
					linkedPrice={false}
					size={priceSize}
					unitQuantity={unitQuantity}
					isScarce={isScarce}
					showFees={facility.showFeeWarning}
					fees={facility.fees}
				/>
			</div>
		</UnitListItem>
	);
}

UnitDetails.propTypes = {
	priceSize: PropTypes.string,
	promotion: PropTypes.string,
	sizeText: PropTypes.string,
	unitTypeText: PropTypes.string,
	price: PropTypes.string,
	className: PropTypes.string,
	regularPrice: PropTypes.string,
	amenitiesText: PropTypes.string,
	vehicleAccommodation: PropTypes.string,
	isScarce: PropTypes.bool,
	unitQuantity: PropTypes.number,
	facility: PropTypes.object,
	showIcon: PropTypes.bool,
	unit: PropTypes.object,
};

UnitDetails.defaultProps = {
	priceSize: 'medium',
};

export default enhance(UnitDetails);

